import { OrganizationIntegrationAccountItem } from "@common/schemas/organization-connection-groups.schema";
import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { ViewConfig } from "@lib/views";
import { ClientCell } from "./Cells/ClientCell";
import { EntityCell } from "./Cells/EntityCell";
import { integrationAccountLabel } from "./integrationAccountLabel";

export type PostConnectAssignmentColumn = "account" | "client" | "entity";

/**
 * Flat, single-connection counterpart to the integrations table's grouped
 * config. The modal only ever shows one connection, so the institution is a
 * banner above the table rather than a collapsible group — which also puts the
 * select-all checkbox where it belongs, on the Account header.
 */
export const postConnectAssignmentViewConfig: ViewConfig<
    OrganizationIntegrationAccountItem,
    PostConnectAssignmentColumn,
    never
> = {
    columns: {
        account: {
            accessorKey: "account",
            name: "Account",
            header: "Account",
            minSize: 280,
            maxSize: 640,
            immutable: true,
            cell: ({ row }) => integrationAccountLabel(row.original),
        },
        client: {
            accessorKey: "client",
            name: "Client",
            header: "Client",
            minSize: 200,
            maxSize: 320,
            immutable: true,
            cell: ({ row }) => <ClientCell item={row.original} />,
        },
        entity: {
            accessorKey: "entity",
            name: "Entity",
            header: "Entity",
            minSize: 200,
            maxSize: 320,
            immutable: true,
            cell: ({ row }) => <EntityCell item={row.original} />,
        },
    },
};

/**
 * Checkboxes are always visible: assigning these accounts in bulk is the point
 * of the screen rather than a shortcut. The select-all header checkbox stays —
 * unlike the table's lazily-paged groups, every account is loaded up front, so
 * "all" here really does mean all of them.
 */
export const postConnectAssignmentView: View = {
    type: ViewType.ORGANIZATION_INTEGRATIONS,
    columns: [{ id: "account" }, { id: "client" }, { id: "entity" }],
    filters: {},
    options: {
        bulkActions: true,
        selection: true,
        alwaysShowSelection: true,
        density: ViewDensity.MD,
    },
};
